// Offline Learning Data
// Structured for Supabase migration with multi-language support

export const offlineLearningData = {
  // Offline Learning Overview
  overview: {
    id: "offline_learning",
    title: {
      tc: "離線學習",
      sc: "离线学习", 
      en: "Offline Learning"
    },
    subtitle: {
      tc: "隨時隨地學習，無需網路連接",
      sc: "随时随地学习，无需网络连接",
      en: "Learn anytime, anywhere without internet connection"
    },
    icon: "download",
    color: "blue"
  },

  // Download Content Section
  downloadContent: {
    id: "download_content",
    title: {
      tc: "下載內容",
      sc: "下载内容",
      en: "Download Content"
    },
    subtitle: {
      tc: "已下載課程",
      sc: "已下载课程",
      en: "Downloaded Courses"
    },
    progress: {
      used: "2.3 GB",
      total: "3.5 GB",
      remaining: "1.2 GB",
      downloadedItems: 8,
      totalItems: 12,
      percentage: 66
    }
  },

  // Downloadable Content
  downloadableContent: {
    id: "downloadable_content",
    title: {
      tc: "可下載內容",
      sc: "可下载内容",
      en: "Downloadable Content"
    },
    courses: [
      {
        id: "basic_conversation",
        title: {
          tc: "基礎對話課程",
          sc: "基础对话课程",
          en: "Basic Conversation Course"
        },
        size: "145 MB",
        status: "downloaded", // downloaded, available, downloading
        icon: "check-circle"
      },
      {
        id: "business_english",
        title: {
          tc: "商務英語",
          sc: "商务英语",
          en: "Business English"
        },
        size: "230 MB",
        status: "downloaded",
        icon: "check-circle"
      },
      {
        id: "ielts_preparation",
        title: {
          tc: "IELTS 準備",
          sc: "IELTS 准备",
          en: "IELTS Preparation"
        },
        size: "380 MB",
        status: "available",
        icon: "download"
      },
      {
        id: "pronunciation_practice",
        title: {
          tc: "發音練習",
          sc: "发音练习",
          en: "Pronunciation Practice"
        },
        size: "156 MB",
        status: "available",
        icon: "download"
      },
      {
        id: "grammar_fundamentals",
        title: {
          tc: "語法基礎",
          sc: "语法基础",
          en: "Grammar Fundamentals"
        },
        size: "210 MB",
        status: "available",
        icon: "download"
      },
      {
        id: "vocabulary_builder",
        title: {
          tc: "詞彙建立",
          sc: "词汇建立",
          en: "Vocabulary Builder"
        },
        size: "180 MB",
        status: "available",
        icon: "download"
      }
    ]
  },

  // Offline Features
  offlineFeatures: {
    id: "offline_features",
    title: {
      tc: "離線功能",
      sc: "离线功能",
      en: "Offline Features"
    },
    features: [
      {
        id: "course_learning",
        title: {
          tc: "課程學習",
          sc: "课程学习",
          en: "Course Learning"
        },
        subtitle: {
          tc: "完整課程內容",
          sc: "完整课程内容",
          en: "Complete Course Content"
        },
        icon: "book-open",
        color: "blue"
      },
      {
        id: "audio_practice",
        title: {
          tc: "音頻練習",
          sc: "音频练习",
          en: "Audio Practice"
        },
        subtitle: {
          tc: "聽力和發音",
          sc: "听力和发音",
          en: "Listening and Pronunciation"
        },
        icon: "headphones",
        color: "green"
      },
      {
        id: "practice_questions",
        title: {
          tc: "練習題目",
          sc: "练习题目",
          en: "Practice Questions"
        },
        subtitle: {
          tc: "互動練習",
          sc: "互动练习",
          en: "Interactive Practice"
        },
        icon: "target",
        color: "purple"
      },
      {
        id: "progress_tracking",
        title: {
          tc: "進度追蹤",
          sc: "进度追踪",
          en: "Progress Tracking"
        },
        subtitle: {
          tc: "本地記錄",
          sc: "本地记录",
          en: "Local Records"
        },
        icon: "trending-up",
        color: "orange"
      }
    ]
  },

  // Download Settings
  downloadSettings: {
    id: "download_settings",
    title: {
      tc: "下載設定",
      sc: "下载设定",
      en: "Download Settings"
    },
    autoDownload: {
      enabled: true,
      wifiOnly: true,
      quality: "high" // low, medium, high
    },
    storage: {
      maxStorage: "5 GB",
      currentUsage: "2.3 GB",
      availableSpace: "12.7 GB"
    }
  }
};
